import React from 'react';
import InvoiceListFunctional from './components/invoice-list-functional';
import './invoice.scss';

const InvoiceList = () => {
	return <InvoiceListFunctional />;
};

export default InvoiceList;
